<template>
  <div class="about">
    <h1>404！ 没有权限！</h1>
  </div>
</template>
